import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { pxToRem } from '../../../assets/styles/helper';
import Modal from '../../Modal/Modal';
import StepByStep from '../../StepByStep';
import { SFH_WIZARD } from '../../../constants/sessionStorage';
import { closeWizardContent } from '../../../util/helpers/wizardHelpers';
import SellFromHomeProductSelection from './SellFromHomeProductSelection';
import SellFromHomeQuantity from './SellFromHomeQuantity';
import SellFromHomeStepsDrawer from './SellFromHomeStepsDrawer';

const SellFromHomeWizard = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const [isStepsDrawerOpen, setIsStepsDrawerOpen] = useState(false);
  const [selectedHit, setSelectedHit] = useState(null);

  useEffect(() => {
    setIsStepsDrawerOpen(isOpen);
    if (!isOpen) {
      setSelectedHit(null);
      closeWizardContent();
    }
  }, [isOpen]);

  const handleClose = () => {
    closeWizardContent();
    setSelectedHit(null);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      close={handleClose}
      title={t('sellWizard.sfhWizard.title')}
      size="sm"
      maxWidth={pxToRem(500)}
      minHeight={pxToRem(576)}
      clipContent
      closeIconVisible
      skipListeningToLocations
    >
      <StepByStep sessionScopeStep={SFH_WIZARD}>
        {({ goStepBack, goStepForward }) => ({
          0: (
            <SellFromHomeProductSelection
              selectedHit={selectedHit}
              setSelectedHit={setSelectedHit}
              handleNext={goStepForward}
            />
          ),
          1: (
            <SellFromHomeQuantity
              selectedHit={selectedHit}
              handleBack={goStepBack}
              handleNext={goStepForward}
              handleClose={handleClose}
            />
          ),
        })}
      </StepByStep>
      <SellFromHomeStepsDrawer
        isOpen={isStepsDrawerOpen}
        onClose={() => setIsStepsDrawerOpen(false)}
      />
    </Modal>
  );
};

SellFromHomeWizard.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export default SellFromHomeWizard;
